import React from 'react'

import { reverse } from 'named-urls'

import { routes } from 'routes'
import { DotStatus } from 'components'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from 'components/Table'
import usePermissions from 'hooks/usePermissions'
import helpers from 'helpers'

const TableRowPlan = ({ plan, ...rest }) => (
  <TableRow {...rest}>
    <TableCell>{plan.id}</TableCell>
    <TableCell>{plan.code}</TableCell>
    <TableCell>{plan.name}</TableCell>
    <TableCell>{plan.periodicity}</TableCell>
    <TableCell align="right">{helpers.currency(plan.price)}</TableCell>
    <TableCell align="center">
      <DotStatus
        statusName={plan.active ? 'Ativo' : 'Inativo'}
        statusTag={plan.active ? 'active' : 'inactive'}
      />
    </TableCell>
  </TableRow>
)

const PlansTable = ({ plans, isLoading }) => {
  const permissions = usePermissions()
  const permittedShowPlan = permissions.permitted('show_plan')

  return (
    <Table
      size="medium"
      emptyMessage="Nenhum plano encontrado"
      isLoading={isLoading}
      noWrap
    >
      <TableHead>
        <TableRow>
          <TableCell>Identificador</TableCell>
          <TableCell>Código</TableCell>
          <TableCell>Nome</TableCell>
          <TableCell>Periodicidade</TableCell>
          <TableCell align="right">Valor</TableCell>
          <TableCell align="center">Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {plans &&
          plans.map(plan => (
            <TableRowPlan
              plan={plan}
              pointer={permittedShowPlan}
              to={
                permittedShowPlan && {
                  pathname: reverse(routes.plans.show, { planId: plan.id }),
                  state: { planCode: plan.code },
                }
              }
              key={plan.id}
              hover
            />
          ))}
      </TableBody>
    </Table>
  )
}

export default PlansTable
